<template>
  <div>
    <div class="photo-album">
      <div class="album-img" ref="listContainer"  v-show="!albumtab">
        <div  class="list-container">
          <div  class="group-items">
            <div v-for="(img,index) in info.pic" :key="index">
              <img v-lazy="ImgPreUrl+img" height="14px" class="meeting-img gallery-img"  @click="carouse(index)"/>
            </div>
          </div>
        </div>
      </div>
      <carousels :info="info.pic" v-if="albumtab" :indexist="indexist"></carousels>
      <!--相册导航-->
      <div class="album-name">
        <div class="rooms-title">
            {{ info.title }}
            <span v-if="info.assist">({{ info.assist }})</span>
        </div>
        <div class="star-content">
            <div>会议室层高：{{ info.high }}m</div>
        </div>
        <div class="star-content">
            <div>会议室面积：{{ info.area }}m²</div>
        </div>
        <div class="star-content">
            <div>会议室柱子：{{ info.pillar | formatVar('MeetingPillar')||'/'}}</div>
        </div>
        <div class="star-content">
            <div>会议室窗户：{{ info.window | formatVar('windowStyle')||'/'}}</div>
        </div>
        <div class="rooms-feature">
            支持布局
        </div>
        <div class="star-layout">
          <div v-for="(item,index) in layout(info.layout_arr)" :key="index">
              <img v-lazy="'/images/bj/icon_'+item.type+'.png'" height="14px" class="star-layout-img"/>
              <p :class="{'text-reds':item.num==''}">{{ item.num||'/' }}<span v-if="item.num">人</span></p>
              <div>{{item.name }}</div>
          </div>
        </div>
        <div class="star-feature" v-if="info.MeetingEquipment.length>0">
            <div class="rooms-feature">
               会议室设备
            </div>
            <div class="star-name" > 
                <div v-for="value in info.MeetingEquipment" :key="value">
                    <i class="el-icon-circle-check"></i>
                    {{ value }}
                </div>
            </div>
        </div>
        <!-- <div class="bottom">去询价</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Carousels from "./Comps/Carousels.vue";
export default {
  name: 'photoAlbum',
  components: {Carousels},
  props: {
    info: {
        type: Object,
        default: () => ({})
    },
  },
  data() {
    return {
      albumtab:false,
      indexist:0,
    };
  },
  computed: {},
  watch: {
    info: {
        handler(newVal, oldVal) {
            this.init();

        },
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init(){
        const info = this.info;
        info.facility=this.$verify.stitch(info.facility);
        info.MeetingEquipment=this.$verify.formatVar(info.facility,'MeetingEquipment');
    },
    //点击放大图片
    carouse(index){
        this.indexist=index;
        this.albumtab=true;
    },
    layout(e){
      let layoutarr=[
          { type: 1, name: '剧院式',num:'',status:true},
          { type: 2, name: '课桌式',num:'',status:true},
          { type: 3, name: '岛屿式',num:'',status:true},
      ];
      if(Array.isArray(e)){
          this.$verify.matchAndAssign(e,layoutarr,'type',['num'])
      }
      return layoutarr
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-album-title{
  text-align: left;
}
.photo-album{
    width: 100%;
    display: flex;
    border-top: 1px #eee solid;
    padding-top: 10px;
}
.album-img{
    width: 76%;
    padding: 0 2%;
    height: 700px;
    overflow: auto;
}
.album-name{
    width: 18%;

    position: relative;
    border-left: 1px #eee solid;
    padding: 0 1%;
}
.group-title {
  font-size: 18px;
  color: #666;
  padding: 10px 0;
  font-weight: bold;
  text-align: left;
}
.group-items{
  width: 100%;
  display: flex;
  flex-wrap:wrap;
  div{
    width: calc(50% - 12px);
    margin-bottom: 12px;
    margin-right: 12px;
    height: 500px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.active{
  background-color: var(--smtc-color-primary);
  color: #fff;
}
.rooms-title{
    text-align: left;
    font-weight: bold;
    font-size: 24px;
    color: #333;
}
.star-content{
    text-align: left;
    display: flex;
    color: #333;
    margin-top: 6px;
    div{
        margin-right: 20px;
        min-width: 60px;
        line-height: 24px;
        display: flex;
    }
    .tel{
        span{
            display: block;
        }
    }
}
.rooms-feature{
    display: flex;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    text-align: left;
    margin-top: 16px;
}
.star-name{
    display: flex;
    flex-wrap: wrap;
    >div{
        width: 50%;
        text-align: left;
        margin-top: 16px;
        display: flex; 
        i{
            font-size: 16px;
            margin-top: 3px;
            margin-right: 6px;
        }
    }
}
.bottom{
    overflow: hidden;
    height: 80px;
    width: 10px;    
}
.Introduction-btn{
  width: 100px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  background-color: var(--smtc-color-primary);
  color: #fff;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.gallery-img{
    cursor: pointer;
}
.star-layout{
  display: flex;
  margin-top: 20px;
  >div{
    width: 50%;
  }
}
.text-red{
    color: #999;
}
.star-layout-img{
  width: 24px;
  height: 24px;
}
</style>
